import { getCookie } from '@atlassian/browser-storage-controls';
const LAST_VIEWED_FORM_COOKIE_NAME_PREFIX = 'lastViewedForm-';
export const getLastViewedForm = projectId => {
  try {
    const lastViewedForm = getCookie(`${LAST_VIEWED_FORM_COOKIE_NAME_PREFIX}${projectId}`);
    if (lastViewedForm) {
      return JSON.parse(lastViewedForm);
    }
    return undefined;
  } catch (err) {
    return undefined;
  }
};